import { useTranslation } from 'react-i18next';

import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes } from '@similarweb/styles';

import { AssetsService } from '../../../../services/AssetsService';

import { StyledEmptyIcon, StyledEmptyText, StyledGenerateButton } from './styles';

type AIOutreachEmptyStateProps = {
  onGenerate: () => void;
  isError: boolean;
};

export const AIOutreachEmptyState = ({ onGenerate, isError }: AIOutreachEmptyStateProps) => {
  const { t } = useTranslation();

  return (
    <>
      <StyledEmptyIcon>
        <img src={AssetsService.assetUrl('/images/empty-state-browser.svg')} alt="" />
      </StyledEmptyIcon>
      <StyledEmptyText>
        {isError
          ? t('common.error', 'Something went wrong. Please try again.')
          : t(
              'company.overview.ai-outreach.empty_text',
              'Generate a personalized outreach email based on company insights'
            )}
      </StyledEmptyText>
      <StyledGenerateButton onClick={onGenerate} data-automation="AIOutreachGenerate">
        <SWReactIcons iconName="sparkles-gradient" size="16px" iconColor={colorsPalettes.carbon[0]} />
        {t('company.overview.ai-outreach.generate', 'Generate')}
      </StyledGenerateButton>
    </>
  );
};
